(function (app) {

    app.directive("phoneInput",
        [
            "$filter", function ($filter) {
                var phoneFilter = $filter("telephone");
                var phoneReverseFilter = $filter("telephoneReverse");
                return {
                    require: "ngModel",
                    scope: {
                    },
                    restrict: "A",
                    link: function (scope, element, attrs, ngModelCtrl) {
                        var formatter = function (value) {
                            return phoneFilter(value);
                        };
                        var parser = function (value) {
                            var caretPosition = element[0].selectionStart;
                            var formatted = phoneReverseFilter(value);
                            element.val(phoneFilter(formatted));

                            element[0].selectionStart = element[0].selectionEnd = caretPosition + 1;

                            return formatted;
                        }

                        ngModelCtrl.$formatters.push(formatter);
                        ngModelCtrl.$parsers.unshift(parser);
                    }
                }
            }
        ]);

})(window.app); //jshint ignore:line